import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';
import type { AxiosResponse } from 'axios';

export const getShippingTransportationGroupsListAPI = () => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetShippingTransportationGroup`,
    method: 'get',
  });
};

export type ShippingTransportationGroupsListResponse = {
  codeDesc: string;
  codeId: string;
}[];

export const fetchShippingTransportationGroupsList = async (): Promise<ShippingTransportationGroupsListResponse> => {
  const response: AxiosResponse<ShippingTransportationGroupsListResponse> =
    await getShippingTransportationGroupsListAPI();
  return response.data;
};
